export const INTERCOM_ID = 'f3dwiisa'
export const SENTRY_URI =
  'https://57e8bfce39904a1f9202634545a1b66d@o102569.ingest.sentry.io/6034176'
export const GP_BOT = '5f7cf7e7b511760a6e147909'
export const S3 = 'https://s3-us-west-2.amazonaws.com/gopeer/static/'

export default {
  INTERCOM_ID,
  SENTRY_URI,
  GP_BOT,
  S3
}
